import React from 'react';
import { Redirect } from 'react-router-dom';
import BookingSearch from 'pages/BookingSearch';
import BookingPath from 'pages/BookingPath';
import ExtrasOnlyBooking from 'pages/ExtrasOnlyBooking';
import BookingSearchResults from 'pages/BookingSearchResults';
import BookingReferenceSearchResults from 'pages/BookingReferenceSearchResults';
import JourneySearch from 'pages/JourneySearch';
import HomePage from 'pages/HomePage';
import LowestFareFinder from 'pages/LowestFareFinder';
import ChangePassword from 'pages/ChangePassword';
import BookingMagnet from 'pages/BookingMagnet';
import Journeys from 'pages/BookingDetails/Journeys';
import Passengers from 'pages/BookingDetails/Passengers';
import Assistance from 'pages/BookingDetails/Assistance';
import Extras from 'pages/BookingDetails/Extras';
import Payments from 'pages/BookingDetails/Payments';
import Notes from 'pages/BookingDetails/Notes';
import Refunds from 'pages/BookingDetails/Refunds';
import AmendBooking from 'pages/AmendBooking';
import Exchange from 'pages/Exchange';
import ExchangeSeatSelection from 'pages/Exchange/ExchangeSeatSelection';
import MissedDepartureSeatSelection from 'pages/Exchange/MissedDepartureSeatSelection';
import FlowForward from 'pages/Exchange/FlowForward';
import ExchangeConfirmation from 'pages/Exchange/ExchangeConfirmation';
import ReviewBookingExtras from 'pages/BookingDetails/ReviewBookingExtras';
import PaymentExchange from 'pages/PaymentExchange';
import PaymentPending from 'pages/PaymentPending';
import RefundMethods from 'pages/RefundMethods';
import Receipt from 'pages/Receipt';
import Shifts from 'pages/Shifts';
import PrrRefund from 'pages/PrrRefund';
import ManageVoucher from 'pages/ManageVoucher';
import VoucherDetails from 'pages/VoucherDetails';
import VoucherList from 'pages/VoucherList';
import { getBookingJourneysURL } from 'utils/urls';
import AddAssistance from 'pages/BookingDetails/AddAssistance';
import CreateVoucher from 'pages/CreateVoucher';
import ManageClubEurostar from 'pages/ManageClubEurostar';
import ClubEurostarMember from 'pages/ClubEurostarMember';
import HotelOnly from 'pages/HotelOnly';
import LiveTravelInformation from 'pages/LiveTravelInformation';
import TravelUpdates from 'pages/TravelUpdates';
import ManageDiscountCode from '../pages/ManageDiscountCode';
import DiscountCodeDetails from '../pages/DiscountCodeDetails';
import DiscountCodeList from '../pages/DiscountCodeList';
import BuyThalysPass from '../pages/BuyThalysPass';
import QuoteConfirmation from 'pages/QuoteConfirmation';
import HotelCompensation from 'pages/HotelCompensation';
import ReviewQuote from 'pages/ReviewQuote';
import CaptureTravelDocuments from '../pages/BookingDetails/CaptureTravelDocuments';
import ExchangeSpecialAssistance from 'pages/Exchange/ExchangeSpecialAssistance';
import GenerateDiscountCode from 'pages/GenerateDiscountCode';
import GenerateBulkVouchers from 'pages/GenerateBulkVouchers';
import ProcessBulkVouchers from 'pages/ProcessBulkVouchers';
import SilverVouchersReport from 'pages/SilverVouchersReport';
import BeMySpecialGuestReport from 'pages/BeMySpecialGuestReport';
import BorderControlRequirements from 'pages/BorderControlRequirements';
import FlowForwardCappedSeatSelection from 'pages/Exchange/FlowForwardCappedSeatSelection';

export const protectedRoutes = [
  {
    path: '/lowest-fare-finder',
    exact: true,
    component: LowestFareFinder
  },
  {
    path: '/',
    exact: true,
    component: HomePage
  },
  {
    path: '/search',
    exact: true,
    component: BookingMagnet
  },
  {
    path: '/journeys',
    component: JourneySearch,
    exact: true
  },
  {
    path: '/extras-only',
    component: ExtrasOnlyBooking,
    exact: true
  },
  {
    path: '/hotel-only',
    component: HotelOnly,
    exact: true
  },
  {
    exact: true,
    path: '/booking/:reference/assistance/add',
    component: AddAssistance
  },
  {
    exact: true,
    path: '/booking/:reference/travel-documents',
    component: CaptureTravelDocuments
  },
  {
    path: '/booking/:reference',
    component: BookingPath
  },
  {
    path: '/search/booking',
    component: BookingSearch
  },
  {
    path: '/manage/bookings/:reference/journeys',
    component: Journeys,
    exact: true
  },
  {
    path: '/manage/bookings/:reference/passengers',
    component: Passengers,
    exact: true
  },
  {
    path: '/manage/bookings/:reference',
    exact: true,
    /* eslint react/prop-types: 0 */
    component: ({ match: { params } }) => {
      const membershipNumber = new URLSearchParams(window.location.search).get('membershipNumber');

      return <Redirect to={getBookingJourneysURL(params.reference, membershipNumber)} />;
    }
  },
  {
    path: '/manage/bookings/:reference/assistance',
    component: Assistance,
    exact: true
  },
  {
    path: '/manage/bookings/:reference/extras',
    component: Extras,
    exact: true
  },
  {
    path: '/manage/bookings/:reference/extras/manage',
    component: AddAssistance,
    exact: true
  },
  {
    path: '/manage/bookings/:reference/extras/review',
    component: ReviewBookingExtras
  },
  {
    path: '/manage/bookings/:reference/payments',
    component: Payments,
    exact: true
  },
  {
    path: '/manage/bookings/:reference/notes',
    component: Notes,
    exact: true
  },
  {
    path: '/manage/bookings/:reference/refunds',
    component: Refunds,
    exact: true
  },
  {
    path: '/manage/bookings/:reference/receipt',
    component: Receipt,
    exact: true
  },
  {
    path: '/manage/bookings/:reference/quote-confirmation',
    component: QuoteConfirmation,
    exact: true
  },
  {
    path: '/manage/bookings/:reference/payment',
    component: PaymentPending
  },
  {
    path: '/manage/bookings/:reference/amend/:id',
    component: AmendBooking
  },
  {
    path: '/manage/bookings/:reference/refund-methods',
    component: RefundMethods
  },
  {
    path: '/manage/bookings/:reference/prr-refund',
    component: PrrRefund
  },
  {
    path: '/manage/bookings/:reference/compensate-hotel',
    component: HotelCompensation
  },
  {
    path: '/exchange/:reference',
    component: Exchange,
    exact: true
  },
  {
    path: '/exchange/:reference/pax',
    component: ExchangeSeatSelection,
    exact: true
  },
  {
    path: '/exchange/:reference/pax/assistance',
    component: ExchangeSpecialAssistance,
    exact: true
  },
  {
    path: '/exchange/:reference/missed-departure/pax',
    component: MissedDepartureSeatSelection,
    exact: true
  },
  {
    path: '/exchange/:reference/flow-forward',
    component: FlowForward,
    exact: true
  },
  {
    path: '/exchange/:reference/flow-forward-capped/pax',
    component: FlowForwardCappedSeatSelection,
    exact: true
  },
  {
    path: '/live-trains',
    component: LiveTravelInformation,
    exact: true
  },
  {
    path: '/travel-updates/:id',
    component: TravelUpdates,
    exact: true
  },
  {
    path: '/border-control-requirements',
    component: BorderControlRequirements,
    exact: true
  },
  {
    path: '/exchange/:reference/confirm',
    component: ExchangeConfirmation
  },
  {
    path: '/exchange/:reference/payment',
    component: PaymentExchange
  },
  {
    path: '/bookings/:reference',
    component: BookingReferenceSearchResults
  },
  {
    path: '/bookings',
    component: BookingSearchResults
  },
  {
    path: '/change-password',
    component: ChangePassword
  },
  {
    path: '/shifts',
    component: Shifts
  },
  {
    path: '/clubeurostar/manage',
    component: ManageClubEurostar
  },
  {
    path: '/clubeurostar/:membershipNumber',
    component: ClubEurostarMember
  },
  {
    path: '/buy-thalys-pass',
    component: BuyThalysPass
  },
  {
    path: '/review-quote-confirmation/:reference',
    component: ReviewQuote
  },
  {
    path: '/vouchers/manage',
    component: ManageVoucher,
    exact: true
  },
  {
    path: '/vouchers/generate-discount-code',
    component: GenerateDiscountCode,
    exact: true
  },
  {
    path: '/vouchers/search',
    component: VoucherList,
    exact: true
  },
  {
    path: '/vouchers/create',
    component: CreateVoucher,
    exact: true
  },
  {
    path: '/vouchers/:voucherAlias',
    component: VoucherDetails
  },
  {
    path: '/discountCodes/search',
    component: DiscountCodeList,
    exact: true
  },
  {
    path: '/discountCodes/manage',
    component: ManageDiscountCode,
    exact: true
  },
  {
    path: '/discountCodes/:discountCodeAlias',
    component: DiscountCodeDetails,
    exact: true
  },
  {
    path: '/generate-bulk-vouchers',
    component: GenerateBulkVouchers,
    exact: true
  },
  {
    path: '/process-bulk-vouchers',
    component: ProcessBulkVouchers,
    exact: true
  },
  {
    path: '/silver-vouchers-report',
    component: SilverVouchersReport,
    exact: true
  },
  {
    path: '/be-my-special-guest-report',
    component: BeMySpecialGuestReport,
    exact: true
  }
];
